import Component from '@glimmer/component';

export default class MwAvatar extends Component {
  get avatarUrl() {
    return '/api/v2/photo/profile/400x400/6065915460e3b24b2bfa4d2a?group=&f=F60258980131MI401E';
  }

  get secondaryAvatarUrl() {
    return '/api/v2/photo/profile/150x150/615ed82346b82e7a0c590591?group=&f=F854449841123YBXQN5';
  }
}
